// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'gear';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M7.965 2.198a1.392 1.392 0 0 0 2.069 0l.673-.739a1.394 1.394 0 0 1 2.426 1.006l-.05.996a1.392 1.392 0 0 0 1.459 1.461l.996-.05a1.394 1.394 0 0 1 1.003 2.426l-.742.67a1.394 1.394 0 0 0 0 2.07l.742.668a1.394 1.394 0 0 1-1.006 2.426l-.996-.05a1.393 1.393 0 0 0-1.462 1.463l.05.996a1.394 1.394 0 0 1-2.42 1.003l-.67-.74a1.394 1.394 0 0 0-2.068 0l-.673.74a1.394 1.394 0 0 1-2.423-1.002l.051-.996a1.394 1.394 0 0 0-1.462-1.463l-.996.05a1.393 1.393 0 0 1-1.008-2.423l.74-.67a1.394 1.394 0 0 0 0-2.07l-.74-.672a1.393 1.393 0 0 1 1.003-2.423l.996.05A1.393 1.393 0 0 0 4.92 3.46l-.048-.997a1.394 1.394 0 0 1 2.423-1.004z' />
    <path d='M5.798 9.002a3.202 3.202 0 1 0 6.404 0 3.202 3.202 0 0 0-6.404 0z' />
  </g>
);

export const viewBox = '0 0 18 18';
